import { useId } from 'react';
import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => {
    const uid = useId();
    const clipId = `${uid}-clip`;
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
            <Defs>
                <ClipPath id={clipId}>
                    <Path fill="#fff" d="M0 0h16v16H0z" />
                </ClipPath>
            </Defs>
            <G clipPath={`url(#${clipId})`}>
                <Path
                    fill={props.color ?? ds.colorValue.icon.inverse}
                    fillRule="evenodd"
                    d="m8 .75-5 3.5v4l5-3.5 5 3.5v-4L8 .75Zm0 5.5-4 2.8v3l4-2.8 4 2.8v-3l-4-2.8Zm-3 6.6 3-2.1 3 2.1v2l-3-2.1-3 2.1v-2Z"
                    clipRule="evenodd"
                />
            </G>
        </Svg>
    );
};
export { SvgComponent as InflatedIcon };
